import $ from "@modules/jquery";

/*
 * De Vue-kaart (assets/js/dashboard-map/) wordt hier TIJDELIJK niet meer
 * geimporteerd. SOIL levert geen Vue en geen @vitejs/plugin-vue, waar het
 * wp-soup-framework dat wel deed (vue 2.7 + vue-loader + een .vue() stap).
 * Met deze import erin faalt de hele front-build, waardoor er niets rendert.
 *
 * Zie docs/wpsoup-naar-soil-migratie.md: de kaart krijgt een eigen buildstap.
 */
$(document).ready(function () {
    //
});
